import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Release\UpdateReleaseController::__invoke
* @see app/Http/Controllers/Release/UpdateReleaseController.php
* @route '/api/sa-management/release/{release}'
*/
const UpdateReleaseController = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateReleaseController.url(args, options),
    method: 'put',
})

UpdateReleaseController.definition = {
    methods: ["put"],
    url: '/api/sa-management/release/{release}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Release\UpdateReleaseController::__invoke
* @see app/Http/Controllers/Release/UpdateReleaseController.php
* @route '/api/sa-management/release/{release}'
*/
UpdateReleaseController.url = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { release: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { release: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            release: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        release: typeof args.release === 'object'
        ? args.release.id
        : args.release,
    }

    return UpdateReleaseController.definition.url
            .replace('{release}', parsedArgs.release.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Release\UpdateReleaseController::__invoke
* @see app/Http/Controllers/Release/UpdateReleaseController.php
* @route '/api/sa-management/release/{release}'
*/
UpdateReleaseController.put = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateReleaseController.url(args, options),
    method: 'put',
})

export default UpdateReleaseController